import type { State } from '../../types';

// True only when the loaded organization data matches the currently selected org id.
// Guards against the org-switch race where state.loaded stays true while
// state.organization still references the previous org.
export function isLoadedForCurrentOrg(state: State): boolean {
  return (
    state.loaded &&
    state.organization !== undefined &&
    state.id !== null &&
    state.organization.organizationId === state.id
  );
}
